// extracted by mini-css-extract-plugin
export default {"Footer_bottom":"FooterBottom_Footer_bottom__pioOW"};